"use strict";

var _interopRequireWildcard = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.split");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var XLSX = _interopRequireWildcard(require("xlsx/xlsx.mjs"));
var _order = require("@/api/order");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _addRisName = _interopRequireDefault(require("./dialogs/addRisName"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    customPage: _customPage.default,
    addRisName: _addRisName.default
  },
  data: function data() {
    return {
      searchForm: {
        name: ""
      },
      total: 0,
      tableData: [],
      editItem: {},
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8"
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    readFile: function readFile(file) {
      //文件读取
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.readAsBinaryString(file); //以二进制的方式读取
        reader.onload = function (ev) {
          resolve(ev.target.result);
        };
      });
    },
    handle: function () {
      var _handle = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(ev) {
        var file, extension, extension2, isLt2M, data, workbook, worksheet, result;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = ev.raw;
                if (!(this.lastUid == file.uid)) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                this.lastUid = file.uid;
                if (!file) {
                  _context.next = 24;
                  break;
                }
                extension = file.name.split(".")[1] === "xls";
                extension2 = file.name.split(".")[1] === "xlsx";
                isLt2M = file.size / 1024 / 1024 < 10;
                if (!(!extension && !extension2)) {
                  _context.next = 11;
                  break;
                }
                this.$message.error("上传模板只能是 xls、xlsx格式!");
                return _context.abrupt("return", false);
              case 11:
                if (isLt2M) {
                  _context.next = 14;
                  break;
                }
                this.$message.error("上传模板大小不能超过 10MB!");
                return _context.abrupt("return", false);
              case 14:
                if (!(file.name.indexOf(".xls") != -1 || file.name.indexOf(".xlsx") != -1)) {
                  _context.next = 24;
                  break;
                }
                _context.next = 17;
                return this.readFile(file);
              case 17:
                data = _context.sent;
                workbook = XLSX.read(data, {
                  type: "binary",
                  cellDates: true
                }); //解析二进制格式数据
                worksheet = workbook.Sheets[workbook.SheetNames[0]]; //获取第一个Sheet
                result = XLSX.utils.sheet_to_json(worksheet); //json数据格式
                console.log(result);
                this.editRiskNameExcels(result);
                // this.$emit("filechange", result);//将数据通过filechange函数，传递给父组件
                return _context.abrupt("return", false);
              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function handle(_x) {
        return _handle.apply(this, arguments);
      }
      return handle;
    }(),
    editRiskNameExcels: function editRiskNameExcels(result) {
      var _this = this;
      (0, _order.editRiskNameExcel)({
        json: JSON.stringify(result)
      }).then(function (res) {
        _this.getList();
      });
    },
    showHandle: function showHandle(data) {
      this.addFlag = data;
    },
    getList: function getList(flag) {
      var _this2 = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      (0, _order.getRiskNameList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this2.tableData = res.data || [];
        _this2.total = res.total;
      });
    },
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      var searchForm = this.$options.data().searchForm;
      this.searchForm = (0, _objectSpread2.default)({}, searchForm);
      this.getList();
    },
    // 修改地址
    editName: function editName() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (item) {
        this.editItem = (0, _objectSpread2.default)({}, item);
      } else {
        this.editItem = {
          id: 0
        };
      }
      this.$refs.addRisName.dialogVisible = true;
    },
    delName: function delName(id) {
      (0, _order.delRiskName)(id).then(function (res) {});
      this.getList();
    },
    // 上传前对文件的格式和大小的判断
    beforeAvatarUpload: function beforeAvatarUpload(ev) {
      var file = ev.raw;
      console.log("sdfsdfsdf");
      console.log(file);
      var extension = file.name.split(".")[1] === "xls";
      var extension2 = file.name.split(".")[1] === "xlsx";
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!extension && !extension2) {
        // this.$message({
        // 	message: '上传模板只能是 xls、xlsx格式!',
        // 	type: 'error'
        // });
        console.log("上传模板只能是 xls、xlsx格式!");
        // this.$message.error("上传模板只能是 xls、xlsx格式!")
        return false; // return false就不会走上传接口
      }

      if (!isLt2M) {
        console.log("上传模板大小不能超过 10MB!");
        // this.$message({
        // 	message: '上传模板大小不能超过 10MB!',
        // 	type: 'error'
        // });
        return false;
      }
      // return extension || extension2 || extension3 || (extension4 && isLt2M);
      return extension || extension2; // 必须要有返回值
    },
    downloadExcel: function downloadExcel() {
      window.location.href = process.env.VUE_APP_BASE_API + "/muban/demo2.xls";
    },
    // 上传成功回调
    uploadSuccess: function uploadSuccess(response, file, fileList) {
      console.log(response, file, fileList, 'ok');
      this.dialogVisible = false; // 关闭弹出框,如果没有可以删除
      if (response.code == 1) {
        // 返回值为1表示上传成功
        this.$message({
          message: response.msg,
          type: 'success'
        });
        this.getList(); // 上传成功之后重新查询列表
      } else {
        this.$message({
          message: response.msg,
          type: 'error'
        });
      }
    }
  }
};
exports.default = _default;